import { render, staticRenderFns } from "./MenuLang.vue?vue&type=template&id=1e92f088"
import script from "./MenuLang.vue?vue&type=script&lang=js"
export * from "./MenuLang.vue?vue&type=script&lang=js"
import style0 from "./MenuLang.vue?vue&type=style&index=0&id=1e92f088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports